/**
 * Search term change handler...exporting for ease of testing
 */
export const onSearchTermChange = (
  setSearchTerm,
  searchEvents,
  clearSearchResults,
  filter,
  e
) => {
  const value = e.target.value;

  setSearchTerm(value);
  if (value.length >= 2) {
    searchEvents(value, filter);
  } else {
    clearSearchResults();
  }
};

/**
 * Search cancel handler, exporting for ease of testing
 * @param {*} setSearchTerm
 * @param {*} clearTeamEventsSearchResults
 */
export const onCancelSearch = (setSearchTerm, clearSearchResults) => {
  setSearchTerm('');
  clearSearchResults();
};
